import React from "react";
import { cls } from "cls";
import FeaturedCategoryItem from "./FeaturedCategoryItem";
import FeaturedCategoryItemData from "./FeaturedCategoryItemData.json";
const FeaturedCategories = () => <div className={cls("container bg-white", "pt-4", "pb-6")} data-sentry-component="FeaturedCategories" data-sentry-source-file="index.tsx">
    <div className={cls("mx-auto", "w-full", "box-border")}>
      <h2 className={cls("text-center", "text-gray-800", "text-2xl", "md:text-3xl", "mb-6", "!leading-none")}>
        Featured Categories
      </h2>
      <div className={cls("clearfix")}>
        <section aria-label="Featured Categories" className={cls("flex")}>
          <ul className={cls("m-0", "grid", "gap-3", "list-none", "grid-cols-2", "md:grid-cols-4", "lt:grid-cols-6")}>
            {FeaturedCategoryItemData.map(item => <FeaturedCategoryItem key={item.id} {...item} />)}
          </ul>
        </section>
      </div>
    </div>
  </div>;
export default FeaturedCategories;